import { z } from 'zod'
import { fileCommonSchema } from './file-common'

export const fileInformationSchema = z.object({
  ...fileCommonSchema.shape,
  /** 副檔名 */
  extension: z.string(),
  /** 檔案大小 */
  size: z.number(),
  /** 路徑 */
  path: z.string()
})

export interface FileInformation
  extends z.infer<typeof fileInformationSchema> {}
